import { render, staticRenderFns } from "./ReportTab.vue?vue&type=template&id=59356f18&scoped=true"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"
import style0 from "./ReportTab.vue?vue&type=style&index=0&id=59356f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59356f18",
  null
  
)

export default component.exports